<template>
  <div class="app-wrapper">
    <Sidebar class="sidebar-container" :collapse="isCollapse" />
    <div class="main-container" :class="{ hasCollapse: isCollapse }">
      <Navbar :is-collapse="isCollapse" @toggle-collapse="toggleCollapse" />
      <AppMain />
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar'
import Navbar from './Navbar'
import AppMain from './AppMain'

export default {
  name: 'Layout',
  components: { Sidebar, Navbar, AppMain },
  data() {
    return {
      isCollapse: false
    }
  },
  methods: {
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    }
  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  display: flex;
  height: 100vh;
  width: 100%;
}
.sidebar-container {
  width: 210px;
  height: 100vh;
  background: #304156;
  transition: width 0.3s;
  overflow: hidden;
  flex-shrink: 0;
}
.sidebar-container.is-collapse {
  width: 64px;
}
.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin-left: 0;
  transition: margin-left 0.3s;
}
</style>
